import { render, staticRenderFns } from "./FormTypeSelect.vue?vue&type=template&id=9d37d03e&scoped=true"
import script from "./FormTypeSelect.vue?vue&type=script&lang=js"
export * from "./FormTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./FormTypeSelect.vue?vue&type=style&index=0&id=9d37d03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d37d03e",
  null
  
)

export default component.exports